import { linkedinConstants } from '@constants/linkedin';

const initialState = {
    data: [],
    loading: true,
    error: '',
};

export function linkedin(state = initialState, action) {
    switch (action.type) {
        case linkedinConstants.LINKEDIN_TARGETS_REQUEST:
            return { ...state, loading: true, error: '' };
        case linkedinConstants.LINKEDIN_TARGETS_SUCCESS:
            return { ...state, loading: false, data: action.data, error: '' };
        case linkedinConstants.LINKEDIN_TARGETS_RESET:
            return { ...state, data: [] };
        case linkedinConstants.LINKEDIN_TARGETS_ERROR:
            return { ...state, loading: false, error: action.message };
        default:
            return state;
    }
}
